import React, { ReactNode, useEffect, useState } from "react";
import Navbar from "../components/navbar/Navbar";
import BottomNav from "../components/navbar/BottomNav";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import "react-photo-view/dist/react-photo-view.css";
import axios from "axios";
import UserDiscovery from "../components/modals/UserDiscovery";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

interface CreateLayoutProps {
  children: ReactNode;
}

const CreateLayout: React.FC<CreateLayoutProps> = ({ children }) => {
  const [shownavbar, setShowNavbar] = useState(true);

  const location = useLocation();
  const { hash, pathname, search } = location;
  const [open, setOpen] = useState(false);
  const [openDiscoveryModel, setOpenDiscoveryModel] = useState(false);

  useEffect(() => {
    function handleResize() {
      if (pathname === "/profile" || pathname === "/edit-profile") {
        setShowNavbar(window.innerWidth >= 767);
      } else {
        setShowNavbar(true);
      }
    }
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, [location]);

  useEffect(() => {
    const callCommonAPI = async () => {
      try {
        if (localStorage.getItem("uid")) {
          const uid = localStorage.getItem("uid");
          const response = await axios.get(`${BASE_URL}/user/${uid}/common`);
          if (response.data.isFirstTime) {
            setOpenDiscoveryModel(true);
          }
        }
      } catch (error) {
        console.error("Error checking user status:", error);
      }
    };

    callCommonAPI();
  }, []);

  return (
    <div className="max-w-screen-xl mx-auto px-4 pb-[95px] lg:pb-10">
      {shownavbar && <Navbar />}
      <BottomNav />
      <div className="mt-[95px]">{children}</div>
      <UserDiscovery
        open={openDiscoveryModel}
        setOpen={setOpenDiscoveryModel}
      />
    </div>
  );
};

export default CreateLayout;
